import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { CourtHeaderHandler } from '@libs/util-services';

/**
 * Handler concreto do click no header da quadra na agenda. Navega pra tela
 * de edição de horários (`lessor-court-editor-time` em
 * `/courts/:courtId/time-details`). A calendar-lib é genérica e não importa
 * Router — esse service é registrado via DI no `app-routes.ts`.
 */
@Injectable({ providedIn: 'root' })
export class LessorCourtHeaderHandler implements CourtHeaderHandler {
  private readonly router = inject(Router);

  async open(courtId: number): Promise<void> {
    if (!courtId) return;
    await this.router.navigate(['/courts', courtId, 'time-details']);
  }
}
